import store from "@/store";
import { DisconnectPayload } from "@/types/disconnect";

const disconnect = {
  receive(payload: DisconnectPayload): void {
    store.commit("UsersModule/setUsers", payload.body.users);
  },
};
export default disconnect;
